import { Alert, Button, Form, Input } from "antd";
import axios from "axios";
import { useState } from "react";
import { Link, useSearchParams } from "react-router";
import { PortalAuthCard } from "../components/PortalProduct";

/** Consumes an agency user's one-time portal password-reset token. */
const PortalResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
  return (
    <PortalAuthCard eyebrow="Partner portal" title="Choose a new password">
      {status ? (
        <Alert className="mt-5" type="success" showIcon message={status} />
      ) : (
        <Form
          className="mt-6"
          layout="vertical"
          requiredMark="optional"
          onFinish={async ({ password, confirmPassword }) => {
            if (password !== confirmPassword) {
              setError("Passwords do not match");
              return;
            }
            try {
              setSubmitting(true);
              setError(null);
              await axios.post("/api/agent-portal/auth/reset-password", {
                token: searchParams.get("token"),
                newPassword: password,
              });
              setStatus("Your password has been reset. You can now sign in.");
            } catch (requestError: unknown) {
              setError(
                axios.isAxiosError<{ error?: string }>(requestError)
                  ? requestError.response?.data?.error || "Unable to reset your password"
                  : "Unable to reset your password",
              );
            } finally {
              setSubmitting(false);
            }
          }}
        >
          {error ? <Alert className="mb-5" type="error" showIcon message={error} /> : null}
          <Form.Item label="New password" name="password" rules={[{ required: true, min: 8 }]}>
            <Input.Password autoComplete="new-password" />
          </Form.Item>
          <Form.Item label="Confirm password" name="confirmPassword" rules={[{ required: true }]}>
            <Input.Password autoComplete="new-password" />
          </Form.Item>
          <Button type="primary" htmlType="submit" block loading={submitting}>
            Reset password
          </Button>
        </Form>
      )}
      <Link className="mt-5 inline-block text-sm text-(--brand-primary)" to="/login">
        Back to sign in
      </Link>
    </PortalAuthCard>
  );
};
export default PortalResetPasswordPage;
